import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    periods: [],
    period: {}
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getAll({ commit }) {
      commit(mutations.LOADING);
      return api.configuration
        .getAll()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    checkActive({ commit }) {
      commit(mutations.LOADING);
      return api.configuration
        .checkActive()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    updatePeriod({ commit }, { id, payload }) {
      commit(mutations.LOADING);
      return api.configuration
        .updatePeriod(id, payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getTolerance({ commit }) {
      commit(mutations.LOADING);
      return api.configuration
        .getTolerance()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    updateTolerance({ commit }, payload) {
      commit(mutations.LOADING);
      return api.configuration
        .updateTolerance(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getAdhoc({ commit }) {
      commit(mutations.LOADING);
      return api.configuration
        .getAdhoc()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    updateAdhoc({ commit }, payload) {
      commit(mutations.LOADING);
      return api.configuration
        .updateAdhoc(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getPODate({ commit }, payload) {
      commit(mutations.LOADING);
      return api.configuration
        .getPODate(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getNonPODate({ commit }, payload) {
      commit(mutations.LOADING);
      return api.configuration
        .getNonPODate(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getPOTime({ commit }) {
      commit(mutations.LOADING);
      return api.configuration
        .getPOTime()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getNonPOTime({ commit }) {
      commit(mutations.LOADING);
      return api.configuration
        .getNonPOTime()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    updatePODate({ commit }, payload) {
      commit(mutations.LOADING);
      return api.configuration
        .updatePODate(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    updateNonPODate({ commit }, payload) {
      commit(mutations.LOADING);
      return api.configuration
        .updateNonPODate(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    updatePOTime({ commit }, payload) {
      commit(mutations.LOADING);
      return api.configuration
        .updatePOTime(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    updateNonPOTime({ commit }, payload) {
      commit(mutations.LOADING);
      return api.configuration
        .updateNonPOTime(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getLoginBlock({ commit }) {
      commit(mutations.LOADING);
      return api.configuration
        .getLoginBlock()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    updateLoginBlock({ commit }, payload) {
      commit(mutations.LOADING);
      return api.configuration
        .updateLoginBlock(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getConfigEmail({ commit }) {
      commit(mutations.LOADING);
      return api.configuration
        .getConfigEmail()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    updateConfigEmail({ commit }, payload) {
      commit(mutations.LOADING);
      return api.configuration
        .updateConfigEmail(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getLockBudget({ commit }) {
      commit(mutations.LOADING);
      return api.configuration
        .getLockBudget()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    updateLockBudget({ commit }, payload) {
      commit(mutations.LOADING);
      return api.configuration
        .updateLockBudget(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getReminderBudget({ commit }, payload) {
      commit(mutations.LOADING);
      return api.configuration
        .getReminderBudget(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    }
  }
};
